import styles from "./styles.module.scss";
import { LastPost } from "../../types/LastPost";
import parse from "html-react-parser";
import Link from "next/link";
import { getMediaImage } from "../../utils/images";
import { MediaSize } from "../../types/MediaImage";
import ArrowLeft from "../../public/static-next/arrow-left.svg";

interface ComponentTypes {
  item: LastPost;
}

export const LastPostComponent = ({ item }: ComponentTypes) => {
  const imgItem = getMediaImage(item.featuredImage, MediaSize.MEDIUM);

  return (
    <div className={styles.articlesNavigation}>
      <h3 className={styles.articlesNavigationTitle}>Próximo artigo</h3>

      <div className={styles.nextArticle}>
        <span className={styles.nextArticleFigure}>
          <span
            className={styles.nextArticleImage}
            style={{ backgroundImage: `url('${imgItem}')` }}
          ></span>
        </span>

        <div className={styles.nextArticleContent}>
          <h4 className={styles.nextArticleTitle}>{item.title}</h4>
          <p className={styles.nextArticleDescription}>
            {parse(item.excerpt.replace(/(<([^>]+)>)/gi, "").substr(0, 140))}
          </p>

          <Link href={item.slug} passHref className={styles.button}>
            <span className={styles.buttonText}>
              Ler artigo completo <ArrowLeft className={styles.arrow} />
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
